import axios from "axios"

async function getPayments() {
    return axios({
        method: "GET",
        url: `/api/v1/payments`,
    })
}

async function getPaymentStatuses() {
    return axios({
        method: "GET",
        url: `/api/v1/payment-statuses`,
    })
}

async function getPaymentsStatusesDetail(uuid:string) {
    return axios({
        method: "GET",
        url: `/api/v1/payment-statuses/${uuid}`,
    })
}


async function getPaymentsStatusesInvoiceDetail(uuid:string) {
    return axios({
        method: "GET",
        url: `/api/v1/invoice/${uuid}/payments`,
    })
}



export {
    getPayments,
    getPaymentsStatusesDetail,
    getPaymentsStatusesInvoiceDetail,
    getPaymentStatuses
}